import styled from 'styled-components';
import {
  LogoImageElement,
  MainNav,
  MainNavFooter,
  MainNavHeader,
  MainNavLogoSection,
  MainNavMenu,
} from './MainNav/MainNavComponents';
import { SubNav, SubNavHeader, SubNavMenu } from './SubNav/SubNavComponents';

export const NavigationArea = styled.div<{ hasSubNav: boolean }>`
  position: relative;
  display: grid;
  grid-template-areas: 'mainNav subNav';
  grid-template-columns: ${props => (props.hasSubNav ? '46px 230px' : '46px 0px')};
`;

export interface IProps {
  /** Url for logo image. */
  logoImageUrl?: string;
  /** Alt Text for image */
  imageAltText?: string;
  /** Heading for the sub nav bar */
  subNavHeading?: string;
  /** Content to be shown in the main nav */
  mainNavContent?: React.ReactNode;
  /** Content to be shown in the sub nav */
  subNavContent?: React.ReactNode;
  /** Invokes a function when the logo is clicked */
  onLogoClicked?: () => void;
  /** Render prop to provide a custom footer implementation. */
  renderFooter?: () => any;
  /** allows user to hide sub nav, defaults to false */
  hideSubNav?: boolean;
}

export const ModularNav = (props: IProps) => {
  return (
    <NavigationArea hasSubNav={!props.hideSubNav}>
      <MainNav data-testid="MainNav">
        <MainNavHeader data-testid="MainNavHeader">
          {props.logoImageUrl && (
            <MainNavLogoSection>
              <LogoImageElement
                src={props.logoImageUrl}
                onClick={props.onLogoClicked}
                role="button"
                alt={props.imageAltText}
              />
            </MainNavLogoSection>
          )}
        </MainNavHeader>
        <MainNavMenu data-testid="MainNavMenu">{props.mainNavContent}</MainNavMenu>
        <MainNavFooter data-testid="MainNavFooter">{props.renderFooter && props.renderFooter()}</MainNavFooter>
      </MainNav>

      {!props.hideSubNav && (
        <SubNav data-testid="SubNav">
          <SubNavHeader data-testid="SubNavHeader">{props.subNavHeading}</SubNavHeader>
          <SubNavMenu data-testid="SubNavMenu">{props.subNavContent}</SubNavMenu>
        </SubNav>
      )}
    </NavigationArea>
  );
};
